module.exports = __webpack_public_path__ + "static/media/3ds Max Asset Library.e181eecf.png";